export default "__VITE_ASSET__B3IQKFmB__"